import SMARTRECIPEZ from '../img/projects/SmartRecipez.png'
import MORNINGBRIEF from '../img/projects/MorningBriefing.png'
// import GAMEOFLIFE from '../img/projects/GameOfLife.JPG'
import FINANCECALCULATOR from '../img/projects/FinanceCalculator.png'

export const projects = [
    {
      image: SMARTRECIPEZ,
      projectUrl: 'https://www.smartrecipez.com/',
      title: 'Smart Recipez',
      description: 'Dietary App that will help users track recipes and allergies'
    },
    {
      image: MORNINGBRIEF,
      projectUrl: 'https://morning-briefing.netlify.com/',
      title: 'Morning Briefing',
      description: `All in one news app, pulling news information from multiple API's.`
    },
    // {
    //   image: GAMEOFLIFE,
    //   projectUrl: 'https://vl-game-of-life.netlify.com/',
    //   title: 'Game of Life',
    //   description: 'Game of Life and its four rules. Solution contains a constant time algorithm for checking for live squares around selected squares.'
    // },
    {
      image: FINANCECALCULATOR,
      projectUrl: 'https://finance-calculator.netlify.com/',
      title: 'Finance Calculator',
      description: 'This calculator will help users solve for future value of cash flows and weighted average cost of capital (WACC)'
    },
    // {
    //   image: 'image src goes here',
    //   projectUrl: 'https://lambdaschool.com/',
    //   title: 'Full Stack Developer',
    //   description: 'this is where you will write about companies'
    // },
    
  ];
  